export default class ProjectModel
{
    constructor(booth_booking, project_info){
        this.booth_booking = booth_booking
        this.project_info = project_info
    }

    toFormData(){
        let fData = new FormData()

        //personal information.
        fData.append('full_name', this.booth_booking.name);
        fData.append('phone', this.booth_booking.phone);

        //project information.
        fData.append('model', this.booth_booking.selectedBoothModel);
        fData.append('location', this.booth_booking.selectedBoothNumber);

        fData.append('date_ini', this.project_info.establishment_date);
        fData.append('project_name', this.project_info.project_name);
        fData.append('category', this.project_info.project_sector);
        fData.append('abstuct', this.project_info.project_summary);
        fData.append('city_id', this.project_info.governorate);
        fData.append('region', this.project_info.region);
        fData.append('instagram', this.project_info.instagram);
        fData.append('facebook', this.project_info.facebook);
        fData.append('tiktok', this.project_info.tiktok);
        fData.append('note', this.project_info.notes);


        return fData
    }
}

